import "bootstrap/dist/css/bootstrap.min.css";

import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/store";

import { useEffect, useState } from "react";
import TopMenuBar from "./TopMenuBar";
import { useCookies } from "react-cookie";
import { setInfo } from "../../store/features/currentSlice";
import { userSessionSchema } from "../../class/user.schema";

const Layout = ({ sessionCookie }: { sessionCookie: any }) => {
  const dispatch = useDispatch();
  const session = useSelector((state: RootState) => state.current.session);
  const [userTitle, setUserTitle] = useState<string>();
  const [isAdmin, setIsAdmin] = useState<boolean>();
  const [cookies] = useCookies();

  const setSessionRedux = (session: any) => {
    if (session !== null && session !== undefined) {
      //Hydration
      const parseResult = userSessionSchema.safeParse(session);
      if (parseResult.success) {
        dispatch(setInfo(parseResult.data));
      } else {
        console.log(`Unable to load session cookie!`);
      }
    }
  };

  useEffect(() => {
    const useSessionCookie =
      !cookies ||
      (sessionCookie !== undefined && sessionCookie?.id !== cookies?.id);
    if (useSessionCookie) {
      console.log(`use-sessionCookie`);
      setSessionRedux(sessionCookie);
    } else {
      console.log(`use-cookies`);
      setSessionRedux(cookies?.session);
    }
  }, [sessionCookie, cookies]);

  useEffect(() => {
    if (!session || session.username?.toString().trim().length === 0) {
      return;
    }
    setIsAdmin(session?.isAdmin === true);
    setUserTitle(session?.username);
  }, [session]);
  return (
    <>
      <TopMenuBar userTitle={userTitle} isAdmin={isAdmin} />
      <Outlet />
    </>
  );
};
export default Layout;
